import { z } from 'zod';
import { apiClient } from '@/lib/axios';
import { config } from '@/config';
import { LoginResponseSchema } from '@/features/auth/types';
// Discovery passthrough schema used during task 3.2 (see integrate-connect-api change).
// Preserved here for reference; the precise schema is now in types/index.ts.
// To re-run discovery: temporarily swap LoginResponseSchema for the line below,
// then check the console.log output and update the schema in types/index.ts.
const _discoveryPassthroughSchema = z.object({ data: z.record(z.string(), z.unknown()) }).passthrough();
export async function loginConnect(firebaseToken) {
    const response = await apiClient.post('/api/v1/auth/login-connect', { firebaseToken });
    if (config.isDevelopment) {
        // Log full response during development to validate schema assumptions (task 3.2)
        console.log('[loginConnect] full response:', response.data);
    }
    return LoginResponseSchema.parse(response.data);
}
